module.exports = __webpack_public_path__ + "static/media/unknown_flag.489ab2fa.svg";